import React from 'react';
import { MetaTags } from '../meta/MetaTags';

type RootProps = {
    children?: React.ReactNode;
};

export function Root(props: RootProps) {
    const { children } = props;

    return (
        <>
            <MetaTags />
            {children}
        </>
    );
}
